import en from '@/plugins/translator/languages/en';
import es from '@/plugins/translator/languages/es';

export default {
    en,
    es
};
